<div class="alert-box">
  <!-- alert message -->
  <div class="alert-box__message">
    <i class="iconsax alert-icon" [attr.icon-name]="messagePreIcon()"></i>
    <span class="alert-message"> {{ alertMessage() | translate }} </span>
  </div>
  <!-- alert question mode -->
  @if (alertMode() === 'question') {
    <div class="alert-box__btns">
      <!-- cancel button -->
      <pwj-button
        color="danger"
        variant="primary"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (click)="onSelectOption(false)">
        {{ 'global.no' | translate }}
      </pwj-button>
      <!-- accept button -->
      <pwj-button
        color="success"
        variant="primary"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (click)="onSelectOption(true)">
        {{ 'global.yes' | translate }}</pwj-button
      >
    </div>
  } @else if (
    alertMode() === 'towRoute' &&
    alertData().firstButtonText &&
    alertData().secondButtonText
  ) {
    <!-- two route mode -->
    <div class="alert-box__btns">
      <!-- first route -->
      <pwj-button
        variant="primary"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (click)="alertData()?.firstButtonAction()"
        >{{ alertData().firstButtonText || '' | translate }}</pwj-button
      >
      <!-- second route -->
      <pwj-button
        variant="primary"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (click)="alertData()?.secondButtonAction()"
        >{{ alertData().secondButtonText || '' | translate }}</pwj-button
      >
    </div>
  } @else if (alertMode() === 'oneRoute') {
    <!-- one route mode -->
    <div class="alert-box__btns">
      @if (alertData().firstButtonText) {
        <!-- first button -->
        <pwj-button
          variant="primary"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          (click)="alertData()?.firstButtonAction()"
          >{{ alertData().firstButtonText || '' | translate }}</pwj-button
        >
      }

      @if (alertData().secondButtonText) {
        <!-- second button -->
        <pwj-button
          variant="secondary"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          (click)="alertData()?.secondButtonAction()"
          >{{ alertData().secondButtonText || '' | translate }}</pwj-button
        >
      }
    </div>
  }
</div>
